// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2KQna","col":"CardReaderDesc_col__M0WTY","label":"CardReaderDesc_label__3yD5R"};